/**
 * delay-scripts.js
 * Releases queued third-party scripts after user interaction or timeout.
 * Works with the inline interceptor in theme.liquid that captures script loads.
 *
 * Scripts are disabled in two ways:
 * 1. Inline interceptor: Catches dynamic .src sets → queues in __delayedScripts
 * 2. Liquid replace: Converts <script src=""> to <script type="text/plain" data-cfh-src="">
 *    so scripts never download during initial page load
 */
(function () {
  'use strict';

  // PERF: Lighthouse/PageSpeed bot detected — never release third-party scripts
  if (window.__isLighthouse) return;

  var TIMEOUT = 20000;

  // Domains/patterns to also catch via MutationObserver (late-injected scripts)
  var blockDomains = [
    'facebook.net',
    'googletagmanager.com',
    'google-analytics.com',
    'googleadservices.com',
    'doubleclick.net',
    'hotjar.com',
    'clarity.ms',
    'freegifts',
    'gift.min.js',
    'loox.io',
    'stamped.io',
    'klaviyo.com',
    'omnisend.com',
    'tidio.co',
    'tawk.to',
    'crisp.chat',
    'intercom',
    'drift.com',
    'zendesk',
    'shop_events_listener',
    'shopifyChatV1',
    'inbox-client',
    'shopify-chat',
    'neon-sign',
    'sign-customiser',
    'spc-b4',
    'globo.formbuilder',
    'secomapp',
    'avada-seo',
    'vitals.co',
    'reconvert',
    'smile.io',
    'aftership',
    'parcel-panel',
    'sealapps',
    'automizely',
    'back-in-stock',
    'bold.cashier',
    'recharge',
    'trackingmore',
  ];

  function isThirdParty(src) {
    if (!src) return false;
    var s = src.toLowerCase();
    for (var i = 0; i < blockDomains.length; i++) {
      if (s.indexOf(blockDomains[i]) !== -1) return true;
    }
    return false;
  }

  function isBlocked(src) {
    var blocked = window.__permanentlyBlockedPatterns || [];
    if (!blocked.length || !src) return false;
    var s = src.toLowerCase();
    for (var i = 0; i < blocked.length; i++) {
      if (s.indexOf(blocked[i]) !== -1) return true;
    }
    return false;
  }

  var activated = false;
  var lateBlockedQueue = [];

  // MutationObserver catches scripts injected AFTER initial parse
  var observer = new MutationObserver(function (mutationsList) {
    if (activated) return;
    for (var m = 0; m < mutationsList.length; m++) {
      var addedNodes = mutationsList[m].addedNodes;
      for (var n = 0; n < addedNodes.length; n++) {
        var node = addedNodes[n];
        if (node.tagName === 'SCRIPT' && node.src && isThirdParty(node.src)) {
          var originalSrc = node.src;
          node.type = 'javascript/blocked';
          node.removeAttribute('src');
          node.setAttribute('data-delayed-src', originalSrc);
          lateBlockedQueue.push(node);
        }
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  function release() {
    if (activated) return;
    activated = true;
    observer.disconnect();

    // Collect scripts from 3 sources:
    // 1. Inline interceptor queue (dynamic .src sets)
    var queue = window.__delayedScripts || [];

    // 2. Late-blocked scripts (MutationObserver caught)
    var lateScripts = lateBlockedQueue.map(function (el) {
      return { src: el.getAttribute('data-delayed-src'), el: el };
    });

    // 3. Liquid-disabled scripts (data-cfh-src from content_for_header)
    var cfhScripts = [];
    document.querySelectorAll('script[data-cfh-src]').forEach(function (el) {
      cfhScripts.push({ src: el.getAttribute('data-cfh-src'), el: el });
    });

    var allScripts = queue.concat(lateScripts, cfhScripts);

    // Filter out permanently blocked scripts
    allScripts = allScripts.filter(function (item) {
      return item.src && !isBlocked(item.src);
    });

    var idx = 0;
    function loadNext() {
      if (idx >= allScripts.length) return;
      var item = allScripts[idx++];
      if (!item.src) {
        loadNext();
        return;
      }

      var script = document.createElement('script');
      script.src = item.src;
      script.async = true;
      script.onload = script.onerror = function () {
        setTimeout(loadNext, 30);
      };
      (document.body || document.head).appendChild(script);
    }

    // Small delay to not compete with main thread
    setTimeout(loadNext, 100);
  }

  // Trigger: user interaction OR timeout
  var events = ['mouseover', 'touchstart', 'scroll', 'keydown'];
  function onInteraction() {
    events.forEach(function (e) {
      document.removeEventListener(e, onInteraction, { passive: true });
    });
    release();
  }
  events.forEach(function (e) {
    document.addEventListener(e, onInteraction, { passive: true });
  });

  setTimeout(release, TIMEOUT);
})();
